export enum SlotStatus {
    Free = 0,     // trống
    Busy = 1,     // giáo viên bận (block)
    Booked = 2    // đã có PH đăng ký
}

export interface IMeetingSlot {
    id: number;
    sis_meeting_id: number;

    start_at: string;

    // NEW
    sis_giaovien_id: number;
    sis_lop_monhoc_id: number;
    status: number;

    sis_giaovien_name: string;
    duration_in_minute: number;
}